import { Button, Text } from 'src/Components'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { setMobileNavIsOpen } from 'src/store/slices/navbar'
import styles from './MobileHeaderModalHeader.module.scss'

export const MobileHeaderModalHeader = () => {
  const dispatch = useDispatch()
  const intl = useIntl()

  const translations = defineMessages({
    label: {
      id: 'MobileHeaderModalHeader.close.button.ariaLabel',
      defaultMessage: 'Close Mobile Navbar Modal',
    },
  })

  return (
    <header className={styles.header}>
      <Button
        aria-label={intl.formatMessage(translations.label)}
        className={styles.button}
        minimal
        onClick={() => dispatch(setMobileNavIsOpen(false))}
      >
        <Text variant='secondary' variantCount='600' weight='semibold'>
          <FormattedMessage
            id='MobileHeaderModal.header.btn'
            defaultMessage='Close'
          />
        </Text>
      </Button>
    </header>
  )
}
